import type { AircraftIconKind, FlightClass } from '@flightscanner/shared';

import type { SatelliteKind, SatelliteRegime } from '../data/types';
import type { VesselIconKind } from '../data/vesselEnrich';

export const AIRCRAFT_CLASSES: { id: FlightClass; label: string; color: string }[] = [
  { id: 'commercial', label: 'Commercial', color: 'bg-accent' },
  { id: 'military', label: 'Military', color: 'bg-mil' },
  { id: 'private', label: 'Private', color: 'bg-[#a78bfa]' },
  { id: 'government', label: 'Government', color: 'bg-[#fbbf24]' },
];

export const AIRCRAFT_ICON_KINDS: { id: AircraftIconKind; label: string; color: string }[] = [
  { id: 'presidential', label: 'Presidential / VIP', color: 'bg-yellow-300' },
  { id: 'emergency', label: 'Emergency', color: 'bg-red-500' },
  { id: 'military-fighter', label: 'Military fighter', color: 'bg-orange-400' },
  { id: 'military-transport', label: 'Military transport', color: 'bg-orange-500' },
  { id: 'military-other', label: 'Military other', color: 'bg-orange-300' },
  { id: 'military-helicopter', label: 'Military helicopter', color: 'bg-orange-500' },
  { id: 'helicopter', label: 'Helicopter', color: 'bg-cyan-400' },
  { id: 'balloon', label: 'Balloon', color: 'bg-pink-400' },
  { id: 'heavy-commercial', label: 'Heavy commercial', color: 'bg-sky-400' },
  { id: 'commercial', label: 'Commercial jet', color: 'bg-blue-400' },
  { id: 'regional', label: 'Regional jet', color: 'bg-cyan-300' },
  { id: 'turboprop', label: 'Turboprop', color: 'bg-cyan-200' },
  { id: 'private-jet', label: 'Private jet', color: 'bg-violet-300' },
  { id: 'light-prop', label: 'Light aircraft', color: 'bg-emerald-200' },
  { id: 'glider', label: 'Glider', color: 'bg-green-200' },
  { id: 'government', label: 'Government', color: 'bg-amber-400' },
  { id: 'unknown', label: 'Unknown', color: 'bg-slate-300' },
];

export const VESSEL_ICON_KINDS: { id: VesselIconKind; label: string; color: string }[] = [
  { id: 'tanker', label: 'Tanker', color: 'bg-orange-500' },
  { id: 'cargo', label: 'Cargo', color: 'bg-sky-400' },
  { id: 'container', label: 'Container', color: 'bg-cyan-400' },
  { id: 'passenger', label: 'Passenger', color: 'bg-violet-400' },
  { id: 'fishing', label: 'Fishing', color: 'bg-emerald-400' },
  { id: 'military', label: 'Military', color: 'bg-orange-400' },
  { id: 'tug', label: 'Tug', color: 'bg-amber-400' },
  { id: 'pleasure', label: 'Pleasure', color: 'bg-violet-300' },
  { id: 'unknown', label: 'Unknown', color: 'bg-slate-300' },
];

export const VESSEL_CLASSES = [
  { id: 'commercial', label: 'Commercial', color: 'bg-accent' },
  { id: 'fishing', label: 'Fishing', color: 'bg-emerald-400' },
  { id: 'pleasure', label: 'Pleasure', color: 'bg-violet-300' },
  { id: 'military', label: 'Military', color: 'bg-mil' },
] as const;

export const SATELLITE_KINDS: { id: SatelliteKind; label: string; color: string }[] = [
  { id: 'starlink', label: 'Starlink', color: 'bg-sky-400' },
  { id: 'station', label: 'Space station', color: 'bg-amber-400' },
  { id: 'navigation', label: 'Navigation', color: 'bg-violet-400' },
  { id: 'agency', label: 'Agency / science', color: 'bg-emerald-400' },
  { id: 'military', label: 'Military', color: 'bg-orange-400' },
  { id: 'geocomms', label: 'GEO comms', color: 'bg-cyan-400' },
  { id: 'constellation', label: 'LEO constellation', color: 'bg-violet-300' },
  { id: 'debris', label: 'Debris', color: 'bg-slate-300' },
];

export const SATELLITE_CLASSES = [
  { id: 'commercial', label: 'Commercial', color: 'bg-accent' },
  { id: 'government', label: 'Government', color: 'bg-[#fbbf24]' },
  { id: 'military', label: 'Military', color: 'bg-mil' },
  { id: 'unknown', label: 'Unknown', color: 'bg-slate-300' },
] as const;

export const SATELLITE_REGIMES: { id: SatelliteRegime; label: string }[] = [
  { id: 'LEO', label: 'LEO' },
  { id: 'MEO', label: 'MEO' },
  { id: 'GEO', label: 'GEO' },
  { id: 'deep-space', label: 'Deep space' },
];
